export const PRIMARY_REGULAR_FONT = "Montserrat Regular";
export const PRIMARY_MEDIUM_FONT = "Montserrat Medium"